import {productConfigUrl, productIdConfig, serviceIdConfig} from "@/config/productConfig";
import CampaignHubService from "@/services/campaignService";
import {getInternalPostbackServiceId} from "@/functions/getInternalServiceId";

export async function userAuthenticate() {
    const urlParams = new URLSearchParams(window.location.search);
    const campaignId = urlParams.get('trfsrc');
    const transactionId = urlParams.get('trxId');
    let msisdn = urlParams.get('msisdn');

    if (!campaignId || !transactionId) {
        throw new Error('Oops something went wrong. Please check your SMS inbox');
    }

    let numericCampaignId = parseInt(campaignId, 10);
    let baseUrl = productConfigUrl.get(numericCampaignId);

    if (!baseUrl) {
        const parts = transactionId.split('-');
        const lastPart = parts[parts.length - 1];
        numericCampaignId = parseInt(lastPart, 10);
        baseUrl = productConfigUrl.get(numericCampaignId);
    }

    if (!baseUrl) {
        throw new Error('Oops something went wrong. Please check your SMS inbox');
    }

    let redirectBaseUrl = msisdn
        ? `${baseUrl}?trxId=${encodeURIComponent(transactionId)}&trfsrc=${encodeURIComponent(campaignId)}&msisdn=${msisdn}`
        : `${baseUrl}?trxId=${encodeURIComponent(transactionId)}&trfsrc=${encodeURIComponent(campaignId)}`;

    // const productId = productIdConfig.get(numericCampaignId);
    // const serviceId = String(serviceIdConfig.get(numericCampaignId))
    // const internalServiceId = getInternalPostbackServiceId(parseInt(serviceId))
    // msisdn = msisdn ?? campaignId // Changed to use campaignId instead

    // await CampaignHubService.handlePostback(
    //     msisdn,
    //     campaignId,
    //     transactionId,
    //     undefined,
    //     undefined,
    //     productId,
    //     internalServiceId
    // );

    return redirectBaseUrl;
}